'use client';
import ProductCarouselPlaceholderComponent, {
  CAROUSEL_HEIGHTS
} from './product-carousel-placeholder.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from '../tabbed-carousel/tabbed-carousel.component';
import dynamic from 'next/dynamic';
import { lazy } from 'react';
import lazyAndDynamicComponentFactory from '../../lazy-and-dynamic/lazyAndDynamicComponentFactory';

const DynamicProductCarouselComponent = dynamic(
  () => import('../tabbed-carousel/tabbed-carousel.component')
);

const LazyProductCarouselComponent = lazy(
  () => import('../tabbed-carousel/tabbed-carousel.component')
);

export default lazyAndDynamicComponentFactory(
  calculateProductCarouselPlaceholderConfig,
  LazyProductCarouselComponent,
  DynamicProductCarouselComponent
);

export function calculateProductCarouselPlaceholderConfig(props: Props): PlaceholderConfig {
  return {
    content: <ProductCarouselPlaceholderComponent {...props} />,
    heightSinceWidth: CAROUSEL_HEIGHTS
  };
}
